// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dsn-dark-mode #RequestContractDialog h1{color:#f4f4f4 !important}.dsn-dark-mode #RequestContractDialog p{color:#a5a6a7 !important}`, "",{"version":3,"sources":["webpack://./src/shared/dialogs/request-contract/request-contract-dialog-dark.scss"],"names":[],"mappings":"AAIQ,yCACI,wBAAA,CAGJ,wCACI,wBAAA","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
